// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
    background: #000000;
    padding: 208px 0 144px 0;
    border-radius: 0;
}

.heading h1 {
    color: #ffffff;
    font-family: Montserrat;
    font-size: 64px;
    font-style: normal;
    font-weight: 900;
    line-height: 64px; /* 100% */
    width: 100%;
}

.heading p {
    color: #ffffff;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    width: 100%;
}

.heading-intro {
    display: flex;
    width: 100%;
    max-width: 476px;
    align-items: flex-start;
    gap: 32px;
    flex-direction: column;
    text-align: initial;
}

.heading-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 48px;
}

.heading-column {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0;
}

.heading-column img {
    width: 100%;
    height: auto;
    z-index: 2;
}

@media screen and (max-width: 1279px){
    .heading h1 {
        font-size: 56px;
        line-height: 56px;
    }
}

@media screen and (max-width: 1199px){
    .heading-intro {
        gap: 24px;
    }

    .heading h1 {
        font-size: 48px;
        line-height: 48px;
    }
}

@media screen and (max-width: 899px) {
    .heading-container {
        flex-direction: column;
        align-items: flex-start;
    }
}


@media screen and (max-width: 600px) {
    .heading h1 {
        font-size: 40px;
        line-height: 40px;
    }

    .heading p {
        font-size: 14px;
    }
}

@media screen and (max-width: 480px) {
    .heading {
        background: #000000;
        padding: 160px 0 120px 0;
        border-radius: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/heading/heading.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;;AAGA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,wBAAwB;QACxB,gBAAgB;IACpB;AACJ","sourcesContent":[".heading {\n    background: #000000;\n    padding: 208px 0 144px 0;\n    border-radius: 0;\n}\n\n.heading h1 {\n    color: #ffffff;\n    font-family: Montserrat;\n    font-size: 64px;\n    font-style: normal;\n    font-weight: 900;\n    line-height: 64px; /* 100% */\n    width: 100%;\n}\n\n.heading p {\n    color: #ffffff;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 24px */\n    width: 100%;\n}\n\n.heading-intro {\n    display: flex;\n    width: 100%;\n    max-width: 476px;\n    align-items: flex-start;\n    gap: 32px;\n    flex-direction: column;\n    text-align: initial;\n}\n\n.heading-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 48px;\n}\n\n.heading-column {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1 0 0;\n}\n\n.heading-column img {\n    width: 100%;\n    height: auto;\n    z-index: 2;\n}\n\n@media screen and (max-width: 1279px){\n    .heading h1 {\n        font-size: 56px;\n        line-height: 56px;\n    }\n}\n\n@media screen and (max-width: 1199px){\n    .heading-intro {\n        gap: 24px;\n    }\n\n    .heading h1 {\n        font-size: 48px;\n        line-height: 48px;\n    }\n}\n\n@media screen and (max-width: 899px) {\n    .heading-container {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n\n@media screen and (max-width: 600px) {\n    .heading h1 {\n        font-size: 40px;\n        line-height: 40px;\n    }\n\n    .heading p {\n        font-size: 14px;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .heading {\n        background: #000000;\n        padding: 160px 0 120px 0;\n        border-radius: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
